import { ComponentMap } from '@cinch-nx/data-storyblok'
import { atomStoryblokComponents } from './atom-storyblok-components-map'
import { moleculeStoryblokComponents } from './molecule-storyblok-components-map'
import { organismStoryblokComponents } from './organism-storyblok-components-map'

export const sharedStoryblokComponents: ComponentMap = {
  ...atomStoryblokComponents,
  ...moleculeStoryblokComponents,
  ...organismStoryblokComponents,
}
